import { render } from "./Matrix.vue?vue&type=template&id=61bb1b23&scoped=true&ts=true"
import script from "./Matrix.vue?vue&type=script&lang=ts"
export * from "./Matrix.vue?vue&type=script&lang=ts"

import "./Matrix.vue?vue&type=style&index=0&id=61bb1b23&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61bb1b23"]])

export default __exports__